export default __webpack_public_path__ + "static/media/arrow-right-up-line-left.58efc3a6.svg";